import { debounce } from 'lodash';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.querySelector('form').addEventListener('submit', (e) =>
      this.onSubmitHandler(e),
    );

    const drawerOpener = document.querySelector('.facets__drawer-opener');
    const drawerContainer = this.querySelector('.facets__drawer');
    if (drawerOpener && drawerContainer) {
      drawerOpener.addEventListener('click', () => {
        drawerContainer.classList.add('open');
        document.querySelector('html').style.overflow = 'hidden';
      });

      const backdrop = drawerContainer.querySelector(
        '.facets__drawer-backdrop',
      );
      if (backdrop) {
        backdrop.addEventListener('click', () => {
          drawerContainer.classList.remove('open');
          document.querySelector('html').style.overflow = '';
        });
      }

      const closeIcon = drawerContainer.querySelector('.facets__drawer-close');
      if (closeIcon) {
        closeIcon.addEventListener('click', () => {
          drawerContainer.classList.remove('open');
          document.querySelector('html').style.overflow = '';
        });
      }
    }

    this.querySelectorAll(
      '.accordion-content .facets__search input[type="text"]',
    ).forEach((searchInput) =>
      searchInput.addEventListener(
        'input',
        debounce(() => {
          FacetFiltersForm.searchFilters(searchInput);
        }, 500),
      ),
    );
  }

  static searchFilters(input) {
    if (!input) return;

    const searchTerms = input.value.toLowerCase();
    const valuesWrapper = input
      .closest('.accordion-content')
      .querySelector('.js-filter');
    if (!valuesWrapper) return;

    if (searchTerms) {
      valuesWrapper.querySelectorAll('.radio, .checkbox').forEach((value) => {
        const label = value.querySelector('label');
        if (!label) return;

        if (label.innerText.toLowerCase().indexOf(searchTerms) < 0) {
          value.classList.add('hidden');
        } else {
          value.classList.remove('hidden');
        }
      });
    } else {
      valuesWrapper
        .querySelectorAll('.radio.hidden, .checkbox.hidden')
        .forEach((value) => {
          value.classList.remove('hidden');
        });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    document.getElementById('ProductGridContainer').classList.add('loading');
    document.querySelector('html').style.overflow = '';
    const filtersDrawer = document.querySelector('.facets__drawer.open');
    if (filtersDrawer) {
      filtersDrawer.classList.remove('open');
    }
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');
    window.scrollTo(0, 0);

    if (window.dAgency.proxyLinkSetup)
      window.dAgency.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.dAgency.ajaxinateCallBack(requestURL);
      },
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    document
      .querySelectorAll('.accordion-content .facets__search input[type="text"]')
      .forEach((searchInput) => FacetFiltersForm.searchFilters(searchInput));
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);
